module.exports = __webpack_public_path__ + "img/formulas-563.44cc14e3.png";